<app-loader *ngIf="isDisabled"></app-loader>
<div>
    <div class="row m-0">
        <div class="col"></div>
        <div class="col-auto">
            <button *ngIf="this.common.PageRight.IsAdd" type="button" class="btn btn-primary" (click)="addLetterTemplate(0)" [disabled]="isDisabled">
                <i class="bi bi-plus-lg" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Add Letter Template':'Loading...'}}
            </button>
        </div>
    </div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Letter Template
        </div>
        <div class="card-body p-1">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th style="width: 5px;">#</th>
                        <th style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">Action</th>
                        <th style="width: 50px;">Code</th>
                        <th>Name</th>
                        <th style="width: 200px;">Document</th>
                        <th style="width: 20px;">Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let TableData of TableDatas; let i = index">
                        <th scope="row" style="width: 5px;">{{i+1}}</th>
                        <td style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">
                            <div class="text-center"><i (click)="addLetterTemplate(TableData['ESS_LetterTemplateMasterID'])"
                                    class="bi bi-pencil-square text-warning"></i></div>
                        </td>
                        <td style="width: 50px;">{{TableData['LetterCode']}}</td>
                        <td>{{TableData['LetterName']}}</td>
                        <td style="width: 200px;">{{TableData['LetterDocumentTypeCode']}} - {{TableData['LetterDocumentTypeName']}}</td>
                        <td style="width: 20px;"><span class="badge"
                                [ngClass]="{'success': TableData['Active'],'danger': !TableData['Active'],}">
                                {{TableData['Active']?'Active':'Deactive'}}</span></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>